// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"935ea4ee","532":"d77bce95","981":"395825ff","983":"935ea4ee"}[chunkId] + ".chunk.css";
};